export default class Trap extends THREE.Group {
	constructor() {
		super();
		this._activated = false;
	}

	init() {
	}

	destroy() {
	}

	update() {
	}
}
